import { render, staticRenderFns } from "./UploadFromNotion.vue?vue&type=template&id=3f3147e3"
import script from "./UploadFromNotion.vue?vue&type=script&lang=js"
export * from "./UploadFromNotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f3147e3')) {
      api.createRecord('3f3147e3', component.options)
    } else {
      api.reload('3f3147e3', component.options)
    }
    module.hot.accept("./UploadFromNotion.vue?vue&type=template&id=3f3147e3", function () {
      api.rerender('3f3147e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload-from-notion/UploadFromNotion.vue"
export default component.exports